import React from "react";
import ReactApexChart from "react-apexcharts";

class LearningDomainsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      options: {
        chart: {
          height: 360,
          type: "area",
          toolbar: { show: false },
          dropShadow: {
            enabled: true,
            top: 10,
            blur: 10,
            opacity: 0.1,
          },
        },
        colors: ["#FFAB2D", "#AC4CBC", "#28a745"],
        dataLabels: {
          enabled: true,
          style: { fontSize: '12px', colors: ['#444'] },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        markers: {
          size: 5,
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 90, 100],
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "14px",
              fontFamily: "Cairo",
              colors: "#787878",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}%`,
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val}%`,
          },
        },
      },
    };
  }

  async componentDidMount() {
    try {
      const response = await fetch("https://plo.areez.co/api/main_domain/category/comparison");
      const json = await response.json();

      const batchNames = json.batches.map(b => b.batch_name);

      const newSeries = json.categories.map(cat => ({
        name: cat.domain_label,
        data: cat.batch_values.map(val => parseFloat(val.average_pct.toFixed(2)))
      }));

      this.setState({
        series: newSeries, // نحدث فقط الموجود
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: batchNames,
          },
        },
      });
    } catch (err) {
      console.error("خطأ في تحميل البيانات:", err);
    }
  }

  render() {
    return (
      <div id="chart">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="area"
          height={320}
        />
      </div>
    );
  }
}

export default LearningDomainsChart;
